// extracted by mini-css-extract-plugin
export default {"agreementText":"AgreementTextV3_agreementText-zxb"};